<template>

    <div>
        <div class="tw-absolute tw-w-full tw-h-full tw-bg-white tw-z-20 tw-opacity-75 tw-rounded" v-if="updating_poll">
                <div class="spinner-container tw-pt-10">
                    <div class="spinner medium">
                        <div class="spinner-wrapper">
                            <div class="rotator">
                                <div class="inner-spin"></div>
                                <div class="inner-spin"></div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
        <template v-if="poll">
            <h2 v-html="poll.questions[0].question" class="tw-mt-4"></h2>
            <div class="all-questions tw-mt-6">
                <p class="tw-text-red-400 tw-font-semibold tw-mb-4 tw-text-sm" v-if="poll_finished">{{ translations['poll.ended'] }}</p>
                <template v-if="all_responses.length > 0">
                    <transition-group name="options" tag="ul" class="tw-pl-0 tw-list-none">
                        <!-- answers -->
                        <poll_multiple_choice v-for="option in orderedOptions" @timePassed="timePassed" @submit="setAllResponses" :ended="poll_finished" :all_responses="all_responses" :key="option.id" :option="option" :question="question" :poll="poll" :poll_settings="poll_settings" :answers="answers"></poll_multiple_choice>

                        <!-- answer collapse -->
                        <div v-if="poll.questions[0].question_options.length > orderedOptions.length" class="tw-flex tw-items-center tw-text-gray-500 tw-mb-3 tw-pl-2 tw-text-base tw-simple-hover" key="expand_answer" @click="expandAnswers">
                            <i class="fa fa-angle-double-down tw-pr-2"></i>
                            <p class="tw-mb-0 tw-font-semibold">Show {{ poll.questions[0].question_options.length - orderedOptions.length }} more answers</p>
                        </div>

                        <!-- new answer -->
                        <template v-if="poll_settings.poll_allow_guest_answers === '1'">
                            <poll_multiple_choice @timePassed="timePassed" @submit="setAllResponses" @questionAdded="expandAnswers" :ended="poll_finished" :key="new_answer_uid" :all_responses="all_responses" :question="question" :poll="poll" :poll_settings="poll_settings" :answers="answers"></poll_multiple_choice>
                        </template>
                    </transition-group>
                </template>
            </div>

            <p class="tw-text-gray-300 tw-text-sm tw-pl-2 tw-mt-1 tw-mb-1" v-if="typeof poll_settings.end_date !== 'undefined'">
                <i class="far fa-clock" style="padding-left: 2px; padding-right: 5px;"></i>
                <template v-if="!poll_finished">
                    {{ translations['poll.until'] }}
                </template>
                <template v-else>
                    {{ translations['poll.until_passed'] }}
                </template>
                {{ end_date }}
            </p>

            <p class="tw-text-gray-300 tw-text-sm tw-pl-2 tw-mt-1 tw-mb-1" v-if="typeof poll_settings.poll_public !== 'undefined' && poll_settings.poll_public === '1'">
                <i class="far fa-eye" style="padding-left: 1px; padding-right: 5px;"></i>
                {{ translations['poll.is_public'] }}
            </p>

            <p class="tw-text-gray-300 tw-text-sm tw-pl-2 tw-mt-1 tw-mb-1" v-if="typeof poll_settings.poll_multiple_answers !== 'undefined' && poll_settings.poll_multiple_answers === '1'">
                <i class="far fa-list" style="padding-left: 2px; padding-right: 6px;"></i>
                {{ translations['poll.multiple_answers_allowed'] }}
            </p>

            <span class="tw-mt-1 tw-block tw-text-sm tw-pl-2 tw-text-gray-300">
                <i class="far fa-users tw-pr-1"></i>
                <template v-if="allResponsesCount === 1">
                    {{ allResponsesCount }} {{ translations['poll.have_voted_singular'] }}
                </template>
                <template v-else>
                    {{ allResponsesCount }} {{ translations['poll.have_voted_plural'] }}
                </template>
            </span>
        </template>
    </div>

</template>


<script>
    import {mapState} from 'vuex';
    import Global from '../../mixins/Global.js'

    let _ = require('lodash');

    export default {
        mixins: [Global],

        name: 'Poll',

        props: ['quizId'],

        data() {
            return {
                poll_settings: [],
                all_responses: [],
                updating_poll: false,
                poll_ended_forced: false, //we use this for when an answer is submitted whilst timer ran out,
                amount_of_responses: false,
                new_answer_uid: Date.now() + ( (Math.random()*100000).toFixed()),
                poll_answers_expanded: false,
            }
        },

        computed: {
            ...mapState('poll',
                ['questions',
                'polls',
                'all_user_responses']
            ),

            ...mapState(['modalData']),

            end_date() {
                return moment(this.poll_settings.end_date).format('D MMMM YYYY, HH:mm');
            },

            poll_finished() {
                if(typeof this.poll_settings.end_date !== 'undefined') {
                    let now = moment().format("YYYY-MM-DD HH:mm:ss");

                    return this.poll_settings.end_date < now || this.poll_ended_forced;
                }

                return false;
            },

            poll: {
                get() {
                    return this.$store.getters['poll/getPollById'](this.quizId);
                },

                set(poll) {
                    this.$set(this.$store.getters['poll/getPollById'](this.quizId).questions, 0, poll);
                }
            },

            answers() {
                let answers = this.$store.getters['poll/getGivenAnswersByPollId'](this.poll.id);

                if(answers.length > 0) {
                    return answers;
                }

                return [];
            },

            orderedOptions() {
                if(this.answers.length > 0 || this.poll_settings.poll_public === '1') {
                    let options = this.poll.questions[0].question_options;

                    for(let i = 0; i < options.length; i++) {
                        let responses_for_option = this.$store.getters['poll/getResponsesForOptionById']({poll_id: this.poll.id, option_id: options[i].id});

                        //if the answer was just added then we won't be able to find any number_of_responses for it
                        if(typeof responses_for_option !== 'undefined') {
                            options[i].number_of_responses = responses_for_option.number_of_responses;
                        } else {
                            options[i].number_of_responses = 0;
                        }
                    }

                    if(!this.poll_answers_expanded) {
                        return _.orderBy(options, 'number_of_responses', 'desc').slice(0, 6);
                    } else {
                        return _.orderBy(options, 'number_of_responses', 'desc');
                    }
                } else {
                    if(!this.poll_answers_expanded) {
                        return this.poll.questions[0].question_options.slice(0, 6);
                    } else {
                        return this.poll.questions[0].question_options;
                    }
                }
            },

            allResponsesCount() {
                return this.all_responses.reduce((acc, answer) => {
                    return acc + answer.number_of_responses 
                }, 0);
            }
        },

        mounted() {
            this.getPoll();
        },

        methods: {
            getPoll () {
                if(this.quizId.length !== 0) {
                    this.$store.dispatch('poll/getPoll', this.quizId)
                        .then(() => {
                            this.getPollSettings();
                            this.getLastPollResponseId();
                            this.getPollQuestion()
                        });
                }
            },

            getPollSettings() {
                let self = this;
                this.$store.dispatch('poll/getPollSettings',this.poll.id)
                    .then(() => {
                        this.poll_settings = this.$store.getters['poll/getPollSettingsByPollId'](self.poll.id).setting;
                    });
            },

            getLastPollResponseId() {
                //get users responses
                this.$store.dispatch('poll/getPollResponseId',this.poll.id)
                    //if we have one, get our last response
                    .then(() => {
                        let response_id = this.$store.getters['poll/getResponseById'](this.poll.id).response_id;

                        this.$store.dispatch('poll/getCurrentProgress', response_id).then(() => {
                            this.getAllUserResponses();
                        });
                    })
                    .catch(() => {
                        //if not, get all other users' responses
                        this.getAllUserResponses();
                    });
            },

            getPollQuestion() {
                let self = this;
                this.$store.dispatch('poll/getQuestion',this.poll.id)
                    .then(() => {
                        self.question = self.questions[this.poll.id][0][0];
                    });
            },
            getAllUserResponses(sync = false) {
                this.$store.dispatch('poll/getUserResponses', this.poll.id).then(() => {
                    this.setAllResponses();

                    if(sync) {
                        this.$store.dispatch('poll/syncPoll', this.poll.id).then(() => {
                            this.updating_poll = false;
                        });
                    }
                });
            },

            setAllResponses() {
                this.all_responses = this.$store.getters['poll/getUserResponsesById'](this.poll.id)[0];
            },

            initEditPoll() {
                let self = this;

                //set topic data for editing
                let pollData = {
                    topContent: this.translations['forum.edit_poll'],
                    icon: 'fa fa-poll-h',
                    poll: this.poll.questions[0],
                    settings: this.poll_settings,
                };

                //set edit topic modal data
                this.$store.commit('setModalData', {
                    modalName: 'EditPoll',
                    modalData: pollData,

                    modalSubmitEmit() {
                        self.updating_poll = true;

                        this.modalData.poll.question = this.modalData.poll.question.value;

                        self.$store.dispatch('poll/updatePoll', self.modalData.poll).then((result) => {
                            self.poll = result;

                            let settings_data = {};
                            settings_data.settings = [];

                            Object.keys(self.modalData.settings).map(function (key, index) {
                                settings_data.settings.push({
                                    'setting': key,
                                    'value': self.modalData.settings[key]
                                })
                            });

                            if(self.modalData.end_date) {
                                settings_data.settings.push({
                                    'setting': 'end_date',
                                    'value': moment(self.modalData.end_date).format('YYYY-MM-DD HH:mm:ss'),
                                })
                            }

                            //update and sync new settings
                            self.$store.dispatch('poll/updatePollSettings', {poll_id: self.poll.id, settings: settings_data}).then((poll) => {
                                self.$store.commit('poll/syncPollSettings', {data: poll, poll_id: self.poll.id});
                                self.poll_settings = self.$store.getters['poll/getPollSettingsByPollId'](self.poll.id).setting;
                            });

                            //update frontend with new data from backend
                            setTimeout(() => {
                                self.getAllUserResponses(true);
                            }, 1000);
                        });
                    }
                });
            },

            timePassed() {
                this.poll_ended_forced = true;
            },

            expandAnswers() {
                this.poll_answers_expanded = true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .quiz-wrapper {
        height: calc(100vh - 90px);
        box-shadow: 0 0px 15px #c3c3c3, 0 0px 15px rgba(195, 195, 195, 0.23);
        transition: box-shadow 0.3s ease-in-out, background 0.3s ease-in-out;

        &:before {
            @apply tw-z-10 tw-absolute tw-left-0 tw-right-0 tw-m-auto;
            width: 96%;
            content: "";
            top: 50px;
            height: 20px;
            background: -webkit-linear-gradient(bottom,rgba(255,255,255,0),#fff);
        }

        &:after {
            @apply tw-z-10 tw-absolute tw-left-0 tw-right-0 tw-m-auto;
            width: 96%;
            content: "";
            bottom: 76px;
            height: 30px;
            background: -webkit-linear-gradient(top,rgba(255,255,255,0),#fff);
        }

        @screen device {
            height: auto;
            width: 650px;
        }
    }

    h2 {
        font-size: 1.5rem !important;
        font-weight: 400 !important;
    }

    .options-move {
        transition: transform 0.5s;
    }

    //spinner
    .spinner {
        display: block;
        margin-top: 2em;
        margin-right: auto;
        margin-left: auto;
        width: 4em;
        height: 4em;
        padding: 7px;
        border: 1px solid #e9eaee;
        border-radius: 50%;
        transform: scale(.7);
        margin-bottom: 50px;
    }

    .medium {
        transform: scale(1);
    }

    .large {
        margin-top: 4em;
        transform: scale(1.5);
    }

    .spinner-wrapper {
        position: relative;
        width: 4em;
        height: 4em;
        border-radius: 100%;
        left: calc(50% - 2em);
        margin-top: -8px;
    }

    .spinner-wrapper::after {
        content: "";
        background: #e9eaee;
        //background: transparent;
        border-radius: 50%;
        width: 3em;
        height: 3em;
        position: absolute;
        top: 0.5em;
        left: 0.5em;
    }

    .rotator {
        position: relative;
        width: 4em;
        border-radius: 4em;
        overflow: hidden;
        animation: rotate 1000ms infinite linear;
    }

    .rotator:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: gray;
        border: 3px solid #e9eaee;
        border-radius: 100%;
    }

    .inner-spin {
        background: #e9eaee;
        height: 4em;
        width: 2em;
    }

    .inner-spin {
        animation: rotate-left 1250ms infinite cubic-bezier(0.445, 0.050, 0.550, 0.950);
        border-radius: 2em 0 0 2em;
        transform-origin: 2em 2em;
    }

    .inner-spin:last-child {
        animation: rotate-right 1250ms infinite cubic-bezier(0.445, 0.050, 0.550, 0.950);
        margin-top: -4em;
        border-radius: 0 2em 2em 0;
        float: right;
        transform-origin: 0 50%;
    }

    @keyframes rotate-left {
        60%, 75%, 100% {
            transform: rotate(360deg);
        }
    }

    @keyframes rotate {
        0% {
            transform: rotate(0);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes rotate-right {
        0%, 25%, 45% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>